import { jsx as o } from "react/jsx-runtime";
import { H as s } from "../../base-nYmjnkiN.js";
import "react";
import { cssX as l } from "../../core/utils/css.js";
import "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const x = ({
  id: t,
  place: r = "bottom",
  variant: i = "light",
  children: m,
  ...p
}) => /* @__PURE__ */ o(
  s,
  {
    id: t,
    place: r,
    variant: i,
    ...p,
    children: /* @__PURE__ */ o("div", { className: l("Tooltip"), children: m })
  }
);
export {
  x as default
};
